import { DXF_MAPPING_ROLE, type DxfMappingRole } from '@frontend/api';

/**
 * Role brush shortcuts, keyed by `KeyboardEvent.code` — physical key position
 * rather than the character, so the binding survives a non-US layout.
 *
 * Ignore's key is `X`, not `I`: the spec's own table reserves the mnemonic
 * letters for Cut/Etch/Bend and gives Ignore a key that cannot collide with a
 * future Insert-shaped tool.
 */
export const BRUSH_HOTKEY_ENTRIES: readonly (readonly [
  string,
  DxfMappingRole,
])[] = [
  ['KeyC', DXF_MAPPING_ROLE.CUTTING],
  ['KeyE', DXF_MAPPING_ROLE.ETCHING],
  ['KeyB', DXF_MAPPING_ROLE.BENDING],
  ['KeyX', DXF_MAPPING_ROLE.IGNORE],
] as const;

/** `KeyboardEvent.code` → role, for the input controller. */
export const BRUSH_HOTKEY_BY_CODE: ReadonlyMap<string, DxfMappingRole> =
  new Map(BRUSH_HOTKEY_ENTRIES);

/** Role → single-letter label (`KeyC` → `C`), for tooltips and the help popover. */
export const brushHotkeyLabel = (role: DxfMappingRole): string => {
  const entry = BRUSH_HOTKEY_ENTRIES.find(
    ([, mappedRole]) => mappedRole === role,
  );
  return entry ? entry[0].replace(/^Key/, '') : '';
};
